module.exports = __webpack_public_path__ + "media/images/frontend/logo-bicentenario-42e3831db19d77e56ccc09c9c50d19ec.png";